<template>
    <div class="page">
      <!-- 搜索 -->
        <el-form
            v-if="isSearch"
            :model="queryForm"
            ref="form"
            label-width="80px"
            :inline="true"
            size="small"
            class="query-form"
            @submit.native.prevent
        >
            <el-form-item label="所属账号">
                <GridSelectU style="width: 200px;" title="选择所属账号" labelName="userName"
                    labelValue="id" :value="queryForm.userId" :limit='1' size='small'
                    placeholder='请选择所属账号'
                    @getValue="getSearchValueUser" :columns="USER_code" :searchs="USER_search"
                    dataListUrl="/mpp/user/findList" entityBeanName="mppUser"
                    queryEntityUrl="/mpp/user/get">
                </GridSelectU>
            </el-form-item>
            <el-form-item label="营业执照名称" label-width="120px">
                 <el-input v-model="queryForm.licenseName" placeholder="请输入营业执照名称" style="width: 250px"></el-input>
            </el-form-item>
           <el-form-item label="组织类型">
                <el-select clearable v-model="queryForm.orgType" style="width: 100px;">
                    <el-option v-for="(item,index) in storeOrgTypeStatusEunmList" :key="index" :value="item.key" :label="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item style="margin-left: 80px">
                <el-button size="small" type="primary" icon="el-icon-search" @click="getBrandList">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
            </el-form-item>
        </el-form>
      <div class="page-content">
        <div class="page-tool-bar">
            <div class="el-btn-group"></div>
            <div class="icon-group">
                <span
                title="搜索"
                class="icon-box"
                @click="search"
                >
                <Icon color="#606266">
                    <Search />
                </Icon>
                </span>
                <span
                class="icon-box"
                @click="refreshAbnormalUserList"
                >
                <Icon color="#606266">
                    <Refresh />
                </Icon>
                </span>
            </div>
        </div>
        <!-- 列表数据 -->
        <el-table
          :data="shopBrandList"
          row-key="id"
          border
          height="100%"
          :header-row-style="{height: '10px'}"
          :header-cell-style="{padding: '10px'}"
          :row-style="{height: '9px'}"
          :cell-style="{padding: '9px'}"
          size="small"
          v-loading="loading"
        >
            <el-table-column :show-overflow-tooltip="true" align="center" width="200px" prop="orgType" label="组织类型">
                <template slot-scope="scope">
                    <el-tag type="warning" v-if="scope.row.orgType == 1">小微</el-tag>
                    <el-tag  v-if="scope.row.orgType == 2">企业</el-tag>
                    <el-tag type="danger" v-if="scope.row.orgType == 3">个体</el-tag>
                </template>
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" align="center" width="200px" prop="licenseName" label="营业执照名称"/>
            <el-table-column :show-overflow-tooltip="true" align="center" width="200px" prop="personName" label="法人姓名"/>
            <el-table-column :show-overflow-tooltip="true" align="center" width="200px" prop="personMobile" label="法人手机号"/>
            <el-table-column :show-overflow-tooltip="true" align="center" width="200px" prop="applyId" label="申请单号"/>
            <el-table-column :show-overflow-tooltip="true" align="center" width="200px" prop="auditStatus" label="审核状态">
                <template slot-scope="scope">
                    <el-tag type="warning" v-if="scope.row.auditStatus == 0">待审核</el-tag>
                    <el-tag type="success" v-if="scope.row.auditStatus == 1">审核通过</el-tag>
                    <el-tag type="danger" v-if="scope.row.auditStatus == 2">审核驳回</el-tag>
                </template>
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" align="center" width="200px" prop="signStatus" label="签约状态">
                <template slot-scope="scope">
                    <el-tag type="warning" v-if="scope.row.signStatus == 0">未签约</el-tag>
                    <el-tag type="success" v-if="scope.row.signStatus == 1">已签约</el-tag>
                    <el-tag type="warning" v-if="scope.row.signStatus == 2">签约中</el-tag>
                    <el-tag type="danger" v-if="scope.row.signStatus == 3">签约失败</el-tag>
                </template>
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" align="center" width="250px" prop="signUrl" label="签约链接"/>
            <el-table-column :show-overflow-tooltip="true" align="center" width="200px" prop="termNo" label="终端号"/>
            <el-table-column :show-overflow-tooltip="true" align="center" width="200px" prop="auditReason" label="审核驳回描述"/>
            <el-table-column :show-overflow-tooltip="true" align="center" width="200px" prop="merchNo" label="商户号"/>
            <el-table-column :show-overflow-tooltip="true" align="center" width="200px" prop="signId" label="协议编号id"/>
            <el-table-column :show-overflow-tooltip="true" align="center" width="200px" prop="subAppidBindRet" label="appid绑定结果">
                <template slot-scope="scope">
                    <el-tag type="success" v-if="scope.row.subAppidBindRet == 0">成功</el-tag>
                    <el-tag type="warning" v-if="scope.row.subAppidBindRet == 1">处理中</el-tag>
                    <el-tag type="danger" v-if="scope.row.subAppidBindRet == 2">失败</el-tag>
                </template>
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" align="center" width="200px" prop="subAppidBindMsg" label="appid绑定结果描述"/>
            <el-table-column :show-overflow-tooltip="true" align="center" width="200px" prop="wechatJsapiPathRet" label="微信支付目录绑定结果">
                <template slot-scope="scope">
                    <el-tag type="success" v-if="scope.row.wechatJsapiPathRet == 0">成功</el-tag>
                    <el-tag type="warning" v-if="scope.row.wechatJsapiPathRet == 1">处理中</el-tag>
                    <el-tag type="danger" v-if="scope.row.wechatJsapiPathRet == 2">失败</el-tag>
                </template>
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" align="center" width="200px" prop="wechatJsapiPathMsg" label="支付目录绑定结果描述"/>
            <el-table-column :show-overflow-tooltip="true" align="center" width="200px" prop="coopBankRet" label="入驻银行合作平台">
                <template slot-scope="scope">
                    <el-tag type="success" v-if="scope.row.coopBankRet == 0">成功</el-tag>
                    <el-tag type="warning" v-if="scope.row.coopBankRet == 1">处理中</el-tag>
                    <el-tag type="danger" v-if="scope.row.coopBankRet == 2">失败</el-tag>
                </template>
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" align="center" width="200px" prop="coopBankMsg" label="入驻银行合作平台描述"/>
            <el-table-column :show-overflow-tooltip="true" align="center" width="200px" prop="auditEndTime" label="审核时间"/>
            <el-table-column :show-overflow-tooltip="true" align="center" width="200px" prop="wechatApplyStatus" label="申请状态">
                <template slot-scope="scope">
                    <el-tag type="warning" v-if="scope.row.wechatApplyStatus == 0">审核中</el-tag>
                    <el-tag type="info" v-if="scope.row.wechatApplyStatus == 1">待确认联系信息</el-tag>
                    <el-tag type="info" v-if="scope.row.wechatApplyStatus == 2">待账户验证</el-tag>
                    <el-tag type="success" v-if="scope.row.wechatApplyStatus == 3">审核通过</el-tag>
                    <el-tag type="danger" v-if="scope.row.wechatApplyStatus == 4">审核驳回</el-tag>
                    <el-tag type="danger" v-if="scope.row.wechatApplyStatus == 5">已冻结</el-tag>
                    <el-tag type="danger" v-if="scope.row.wechatApplyStatus == 6">已作废</el-tag>
                    <el-tag type="success" v-if="scope.row.wechatApplyStatus == 7">已授权</el-tag>
                </template>
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" align="center" width="200px" prop="wechatQrcode" label="微信二维码">
                <template slot-scope="scope">
                    <el-image 
                        v-if="scope.row.wechatQrcode"
                        :src="scope.row.wechatQrcode"
                        :preview-src-list="[scope.row.wechatQrcode]"
                        fit="cover"
                        style="width: 80px; height: 80px;"
                    />
                </template>
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" align="center" width="200px" prop="wechatRejectParam" label="微信申请驳回参数"/>
            <el-table-column :show-overflow-tooltip="true" align="center" width="200px" prop="wechatRejectReason" label="驳回原因"/>
            <el-table-column :show-overflow-tooltip="true" align="center" width="200px" prop="wechatAuthorizeStatus" label="授权状态">
                <template slot-scope="scope">
                    <el-tag type="danger" v-if="scope.row.wechatAuthorizeStatus == 0">未授权</el-tag>
                    <el-tag type="success" v-if="scope.row.wechatAuthorizeStatus == 1">已授权</el-tag>
                </template>
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" align="center" width="200px" prop="aliApplyStatus" label="支付宝申请状态">
                <template slot-scope="scope">
                    <el-tag type="warning" v-if="scope.row.aliApplyStatus == 0">审核中</el-tag>
                    <el-tag type="info" v-if="scope.row.aliApplyStatus == 1">待确认联系信息</el-tag>
                    <el-tag type="info" v-if="scope.row.aliApplyStatus == 2">待账户验证</el-tag>
                    <el-tag type="success" v-if="scope.row.aliApplyStatus == 3">审核通过</el-tag>
                    <el-tag type="danger" v-if="scope.row.aliApplyStatus == 4">审核驳回</el-tag>
                    <el-tag type="danger" v-if="scope.row.aliApplyStatus == 5">已冻结</el-tag>
                    <el-tag type="danger" v-if="scope.row.aliApplyStatus == 6">已作废</el-tag>
                    <el-tag type="success" v-if="scope.row.aliApplyStatus == 7">已授权</el-tag>
                </template>
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" align="center" width="200px" prop="aliQrcode" label="支付宝二维码">
                <template slot-scope="scope">
                    <el-image 
                        v-if="scope.row.aliQrcode"
                        :src="scope.row.aliQrcode"
                        :preview-src-list="[scope.row.aliQrcode]"
                        fit="cover"
                        style="width: 80px; height: 80px;"
                    />
                </template>
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" align="center" width="200px" prop="aliRejectParam" label="支付宝申请驳回参数"/>
            <el-table-column :show-overflow-tooltip="true" align="center" width="200px" prop="aliRejectReason" label="驳回原因"/>
            <el-table-column :show-overflow-tooltip="true" align="center" width="200px" prop="aliAuthorizeStatus" label="支付宝授权状态">
                <template slot-scope="scope">
                    <el-tag type="danger" v-if="scope.row.aliAuthorizeStatus == 0">未授权</el-tag>
                    <el-tag type="success" v-if="scope.row.aliAuthorizeStatus == 1">已授权</el-tag>
                </template>
            </el-table-column>
            <el-table-column align="center" label="操作" width="300px" fixed="right">
                <template slot-scope="scop">
                    <div class="operation">
                        <div class="primary" v-if="!scop.row.applyId" @click="merchantEntry(scop.row)" style="background-color:  #FF6356;">商户入驻</div>
                        <div class="primary" v-if="scop.row.applyId" @click="merchantQuery(scop.row)" style="background-color: #C71585;color: #fff;">申请单查询</div>
                        <div class="primary" v-if="scop.row.auditStatus == 1 || scop.row.auditStatus == 2" @click="modifyMerchantInfo(scop.row)" style="background-color: #e66d0fe3;">修改商户信息</div>
                        <div class="primary" @click="realNameAuthQuery(scop.row,0)" style="background-color: #7FB77E;">微信实名认证状态结果查询</div>
                        <div class="primary" @click="realNameAuthQuery(scop.row,1)" style="background-color: #e66d0fe3;">支付宝实名认证状态结果查询</div>
                        <div class="primary" v-if="scop.row.auditStatus === 0 || scop.row.auditStatus == 2" @click="realNameAuthAuthQuery(scop.row)" style="background-color: #BC8F8F;">申请单作废</div>

                        <div class="primary" style="background-color: #e7e7e7;color:#666666;" @click="checkShopStoreOrgInfo(scop.row)">查看</div>
                        <div class="primary" @click="editShopStoreOrgInfo(scop.row)">修改</div>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-box">
          <el-pagination
            @size-change="sizeChange"
            @current-change="currentChange"
            :current-page.sync="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum"
            background
            :pager-count="7"
          >
          </el-pagination>
        </div>
      </div>
      <quickPayment v-if="drawer" :orgObj="orgObj" :storeObj="storeObj"   :drawer="drawer" :title="title"  @updateDrawer="updateDrawer" :disabled="disabled" ></quickPayment>
    </div>
</template>
  
<script>
import { Refresh,  Search } from '@v2icons/tabler';
import { get } from '@/utils/request.js';
import quickPayment  from './common/quickPayment.vue'
import GridSelectU from '@/components/gridselect/index.vue';
import { USER, USER_SEARCH } from '@/utils/constant';
  
export default {
    components: {
      Refresh,
      Search,
      quickPayment,
      GridSelectU,
    },
    data() {
        return {
            USER_code: USER,
            USER_search: USER_SEARCH,
            storeOrgTypeStatusEunmList: [ 
                {
                    key: 1,
                    value: '小微',
                },
                {
                    key: 2,
                    value: '企业',
                },
                {
                    key: 3,
                    value: '个体',
                }
            ],
            queryForm: {
                userId:"",//用户ID
                orgType: "", //组织类型：1小微 2企业 3个体
                licenseName:"", //营业执照名称
            },
            loading: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            shopBrandList: [],
            drawer: false,
            disabled: true,
            title: "进件详情",
            orgObj: {}, // 组织信息
            storeObj: {}, // 店铺信息
        };
    },
    mounted() {
        this.getEnum();
        this.getBrandList();
    },
    methods: {
        // 商户入驻
        merchantEntry(row){
            this.$confirm('确认要进行商户入驻吗?', '提示', {
                type: 'warning'
            }).then(()=>{
                this.loading = true;
                get('/jlStore/register',{ 
                    storeId: row.storeId
                }).then(res => {
                    this.loading = false;
                    if (res.success) {
                        this.$message.success(res.msg);
                        this.getBrandList();
                    }else{
                        this.$message.error(res.msg);
                    }
                })
            })
        },
        // 申请单查询
        merchantQuery(row){
            this.$confirm('确认要进行申请单查询吗?', '提示', {
                type: 'warning'
            }).then(()=>{
                this.loading = true;
                get('/jlStore/queryByStoreId',{ 
                    storeId: row.storeId
                }).then(res => {
                    this.loading = false;
                    if (res.success) {
                        this.$message.success(res.msg);
                        this.getBrandList();
                    }else{
                        this.$message.error(res.msg);
                    }
                })
            })
        },
        // 修改商户信息
        modifyMerchantInfo(row){
            this.$confirm('确认要修改商户信息吗?', '提示', {
                type: 'warning'
            }).then(()=>{
                this.loading = true;
                get('/jlStore/updateByStoreId',{ 
                    storeId: row.storeId
                }).then(res => {
                    this.loading = false;
                    if (res.success) {
                        this.$message.success(res.msg);
                        this.getBrandList();
                    }else{
                        this.$message.error(res.msg);
                    }
                })
            })
        },
        // 实名认证审核状态结果查询
        realNameAuthQuery(row,type){
            this.$confirm('确认要查询实名认证状态吗?', '提示', {
                type: 'warning'
            }).then(()=>{
                this.loading = true;
                get('/jlStore/rateSet',{ 
                    storeId: row.storeId,
                    type: type
                }).then(res => {
                    this.loading = false;
                    if (res.success) {
                        this.$message.success(res.msg);
                        this.getBrandList();
                    }else{
                        this.$message.error(res.msg);
                    }
                })
            })
        },
        // 申请单作废
        realNameAuthAuthQuery(row){
            this.$confirm('确认要作废申请单吗?', '提示', {
                type: 'warning'
            }).then(()=>{
                this.loading = true;
                get('/jlStore/rateQuery',{ 
                    storeId: row.storeId
                }).then(res => {
                    this.loading = false;
                    if (res.success) {
                        this.$message.success(res.msg);
                        this.getBrandList();
                    }else{
                        this.$message.error(res.msg);
                    }
                })
            })
        },
        // 搜索box
        search() {
            this.isSearch = !this.isSearch;
        },
        //重置查询条件
        resetDialog() {
            this.queryForm.userId = '';
            this.queryForm.licenseName = '';
            this.queryForm.orgType = '';
            this.getBrandList();
        },
        refreshAbnormalUserList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.shopBrandList = [];
            this.getBrandList();
        },
        // 获取列表信息
        getBrandList() {
            this.loading = true;
            get('/jlStore/findList',{ 
                ...this.queryForm,
                pageSize: this.pageSize,
                pageNum: this.currentPage
            }).then(res => {
                this.loading = false;
                if (res.success) {
                    this.shopBrandList = res.pageInfo.list
                    this.totalNum = res.pageInfo.total

                }else{
                    this.$message.error(res.data.msg);
                }
            })
        },
        currentChange(page) {
            this.currentPage = page;
            this.getBrandList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getBrandList();
        },
        updateDrawer(val){
            this.drawer=val
            this.getBrandList()
        },
        //  查看
        checkShopStoreOrgInfo(row){
            this.incomingData(row)
            this.disabled = true
            this.drawer = true
        },
        // 修改
        editShopStoreOrgInfo(row){
               this.incomingData(row)
               this.disabled = false
               this.drawer = true
        }, 
        // 查询进件接口
        incomingData(row){
             get('/shop/store/findById',{
                storeId: row.storeId
            }).then((res)=>{
                if(res.code == 200){
                    this.orgObj = res.data.org
                    this.storeObj = res.data.store
                }
            })
        }, 
        // 所属账号-搜索项回填
        getSearchValueUser(val){
            this.queryForm.userId = val;
        },
        // 获取枚举
        getEnum(){
            get('/shop/utils/getEnum',{
                enumType: "store_org_type_status"
            }).then((res)=>{
                if(res.success){
                    this.storeOrgTypeStatusEunmList = res.enumList;
                }
            })
        },
    }
};
</script>
  
<!-- 添加全局样式 -->
<style lang="scss">
.el-image-viewer__img {
    background-color: #fff !important;
}
</style>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.operation {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-evenly;
    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }
    .primary{
        background-color: #409eff;
        color: #fff;
        border-radius: 4px;
        height: 28px;
        line-height: 28px;
        margin-top: 15px;
        padding: 0 15px;
        // min-width: 60px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .danger{
        background-color: #f56c6c;
        color: #fff;
        border-radius: 4px;
        height: 28px;
        line-height: 28px;
    }
}
::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 178px;
    height: 178px;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 178px;
    text-align: center;
}
.avatar {
    width: 178px;
    height: 178px;
    display: block;
}
.logo-img {
    margin-left: 50%;
    transform: translate(-50%, 0);
}
.count{
    margin-right:1.5625vw;
}
</style>
  
  